<template>
    <div class="plan">
        <el-dialog :title="edit_id == 0 ? '新增店铺' : '编辑店铺'" :visible.sync="dialogVisible" width="992px" :before-close="handleClose">
            <div class="main scroll-auto">
                <div class="form">
                    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                        <el-form-item label="店铺名称：" prop="name">
                            <el-input v-model="ruleForm.name" clearable class="w400" placeholder="请输入店铺名称"></el-input>
                        </el-form-item>
                        <el-form-item label="店铺URL：" prop="url">
                            <el-input v-model="ruleForm.url" clearable class="w400" placeholder="请输入店铺URL"></el-input>
                        </el-form-item>
                        <el-form-item label="是否授权：" prop="is_auth">
                            <el-radio-group v-model="ruleForm.is_auth">
                                <el-radio label="1">是</el-radio>
                                <el-radio label="2">否</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <!-- <el-form-item label="采集选项：" prop="crawl_type">
                            <el-radio-group v-model="ruleForm.crawl_type">
                                <el-radio label="1">计算折扣价</el-radio>
                                <el-radio label="2">按面价计算</el-radio>
                            </el-radio-group>
                        </el-form-item> -->
                    </el-form>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="onSubmit">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
    data() {
        return {
            dialogVisible: false,
            ruleForm: {
                name: "",
                is_auth: "1",
                url: "",
                // crawl_type: "1",
            },
            rules: {
                name: [{ required: true, message: "请输入店铺名称", trigger: "blur" }],
                url: [{ required: true, message: "请输入店铺URL", trigger: "blur" }],
                is_auth: [{ required: true, message: "请选择是否授权", trigger: "change" }],
                // crawl_type: [{ required: true, message: "请选择采集选项", trigger: "blur" }],
            },
            edit_id: 0,
        };
    },
    computed: {
        ...mapGetters({
            getToken: "getToken",
        }),
    },
    methods: {
        ...mapActions({
            shopAdd: "detect/shopAdd",
            shopEdit: "detect/shopEdit",
        }),
        onSubmit() {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    let { name, is_auth, url, crawl_type } = this.ruleForm;
                    let params = {
                        token: this.getToken,
                        name,
                        is_auth,
                        url,
                        // crawl_type,
                    };
                    let urlApi;
                    if (this.edit_id == 0) {
                        urlApi = this.shopAdd;
                    } else {
                        params.id = this.edit_id;
                        urlApi = this.shopEdit;
                    }
                    urlApi(params).then(({ data }) => {
                        if (data.code == 1) {
                            this.$message.success(this.edit_id == 0 ? "添加成功！" : "修改成功！");
                            this.handleClose();
                            this.$emit("init");
                        } else {
                            this.$message.error(data.msg);
                        }
                    });
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        handleClose() {
            this.dialogVisible = false;
            this.$refs.ruleForm.resetFields();
            this.ruleForm = {
                name: "",
                is_auth: "1",
                url: "",
                // crawl_type: "1",
            };
            this.edit_id = 0;
        },
    },
};
</script>

<style lang="scss" scoped>
.main {
    height: 450px;

    .form {
        margin: 0 40px;
    }
    .table {
        p {
            margin: 20px 0;
            color: #999;
        }
    }
    .subtitle {
        margin-bottom: 35px;
        display: flex;
        align-items: center;
        .btn {
            margin-left: 40px;
            display: flex;
            justify-content: space-between;
            flex: 1;
        }
        h4 {
            padding-left: 20px;
            line-height: 18px;
            position: relative;
            font-size: 16px;
            font-weight: bold;
            color: #333333;
            &::before {
                content: "";
                position: absolute;
                left: 0;
                top: 0;
                height: 100%;
                width: 2px;
                background: #2448ff;
            }
        }
    }
}
.w400 {
    width: 400px;
}
.link {
    a {
        margin: 0 8px;
    }
}
</style>